<template>
<div class="bodyStyle">
  <el-card class="box-card" style="margin-top: 40px;">
    <div slot="header" class="clearfix" style="text-align: center;font-weight: bold;color: red;font-size: 20px;">
      <span>注册老师账号</span>
    </div>
     <div>
       <el-form :model="registeForm" :rules="rules" ref="registeForm" label-width="150px" class="demo-ruleForm">
         <el-form-item label="登录手机号" prop="username">
           <el-input v-model="registeForm.username" placeholder="请输入手机号"></el-input>
         </el-form-item>
         <el-form-item label="登录密码" prop="password">
           <el-input v-model="registeForm.password" placeholder="请输入登录密码"></el-input>
         </el-form-item>
         <el-form-item label="您的姓名" prop="teacher_name">
           <el-input v-model="registeForm.teacher_name" placeholder="请输入您的姓名"></el-input>
         </el-form-item>
         <el-form-item label="学校名称" prop="school_name">
           <el-input v-model="registeForm.school_name"  placeholder="请输入学校名称"></el-input>
         </el-form-item>
         <el-form-item>
           <el-button type="primary" @click="submitForm('registeForm')">立即注册</el-button>
           <el-button @click="resetForm('registeForm')">重填</el-button>
            <el-button @click="backForm()">返回</el-button>
         </el-form-item>
       </el-form>
     </div>
  </el-card>
</div>
</template>

<script>
export default {
  data () {
    return {
      registeForm: {
        username: '',
        password: '',
        teacher_name: '',
        school_name: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入登录手机号', trigger: 'blur' },
          { min: 1, max: 11, message: '长度11位的数字', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        teacher_name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        school_name: [
          { required: true, message: '请输入学校名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this

          if (!this.isPhone(this.registeForm.username)) {
             this.$message.error('电话号码格式不正确，请重新输入')
             return
          }

          if (this.registeForm.password.length<4) {
             this.$message.error('密码不能少于4个字符！')
             return
          }

          if (this.registeForm.teacher_name.length<2) {
             this.$message.error('您的姓名不能少于2个字符！')
             return
          }

          if (this.registeForm.school_name.length<2) {
             this.$message.error('学校名称不能少于2个字符！')
             return
          }

          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          // 注册接口
          var requestUrl = '/score/web/_registe_teacher.jsp'
          this.axios.get(requestUrl, {
            params: {
              username: that.registeForm.username,
              password: that.registeForm.password,
              teacher_name: that.registeForm.teacher_name,
              school_name: that.registeForm.school_name
            }
          }).then(function (response) {
            console.log(response.data.result)
            var result = response.data.result
            if (result === '1') {
              that.$message('注册成功！')
              that.$router.push('/exam_list')
            } else {
              that.$message.error('注册失败！账号已经存在，换个试试！')
            }

            load.close()
          })
            .catch(function (error) {
              console.log(error)
              load.close()
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    backForm () {
      this.$router.push('/')
    }
  }
}
</script>

<style>

  .bodyStyle{
    display: flex;
    justify-content: center;
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/registe_teacher.vue